export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Custom scalar date type: YYYY-MM-DD */
  Date: any;
  /** Custom scalar date type: MM/YYYY */
  DateRegister: any;
  /** Custom scalar DateTimeISO type: YYYY-MM-DDTHH:mm:ssZ */
  DateTime: any;
};

export type AccessoriesProvider = {
  __typename?: 'AccessoriesProvider';
  makeName: Scalars['String'];
  providerId: Scalars['String'];
};

export type Accessory = {
  __typename?: 'Accessory';
  articleNo?: Maybe<Scalars['String']>;
  carLines?: Maybe<Array<Scalars['String']>>;
  dealerId: Scalars['String'];
  deliveryTime?: Maybe<DeliveryTime>;
  images?: Maybe<Array<Maybe<ProductImage>>>;
  mainCategoryName?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  sku: Scalars['ID'];
  specification?: Maybe<Scalars['String']>;
  sumPrice?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  unitPrice?: Maybe<Scalars['Float']>;
};

export type AccessoryBrand = {
  __typename?: 'AccessoryBrand';
  dealerId: Scalars['String'];
  distributorId: Scalars['String'];
  name: Scalars['String'];
};

export type AccessoryCategory = {
  __typename?: 'AccessoryCategory';
  count: Scalars['Int'];
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownCount: Scalars['Int'];
};

export type AccessoryDetails = {
  __typename?: 'AccessoryDetails';
  accessory: Accessory;
  recommendedProducts?: Maybe<Array<Accessory>>;
};

export type AccessoryFilterOptions = {
  categoryId?: InputMaybe<Scalars['String']>;
  dealerId: Scalars['String'];
  model?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type AccessoryModelVariants = {
  __typename?: 'AccessoryModelVariants';
  image?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  variants?: Maybe<Array<Scalars['String']>>;
};

export type AccessoryOptionsInput = {
  dealerId: Scalars['String'];
  productId: Scalars['String'];
};

export type AccessoryPaginationOptions = {
  pageNo: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type AccessoryPriceDetails = {
  __typename?: 'AccessoryPriceDetails';
  catalogProductId: Scalars['String'];
  price: Scalars['Float'];
  productId: Scalars['String'];
  shippingOptions: Array<Shipment>;
};

export type AccessoryProvider = {
  __typename?: 'AccessoryProvider';
  authCode?: Maybe<Scalars['String']>;
  carBrand?: Maybe<Scalars['String']>;
  dataSource?: Maybe<Scalars['String']>;
  dataSourceId?: Maybe<Scalars['String']>;
};

export type AccessorySearchOptions = {
  categoryId?: InputMaybe<Scalars['String']>;
  dealerId: Scalars['String'];
  model?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
  variant?: InputMaybe<Scalars['String']>;
};

export type AccessoryShippingOption = {
  __typename?: 'AccessoryShippingOption';
  price: Scalars['Float'];
  shippingType: AccessoryShippingType;
};

export enum AccessoryShippingType {
  Delivery = 'DELIVERY',
  PickUp = 'PICK_UP',
  PickUpWithInstallation = 'PICK_UP_WITH_INSTALLATION'
}

export type AccessorySortingOptions = {
  direction?: InputMaybe<SortingDirection>;
  subject?: InputMaybe<AccessorySortingSubject>;
};

export enum AccessorySortingSubject {
  Name = 'NAME',
  Popularity = 'POPULARITY',
  Price = 'PRICE'
}

export type AddToCartInput = {
  items: Array<CartItemInput>;
};

export type AdditionalDocuments = {
  actingFlag: Scalars['Boolean'];
  contractFlag: Scalars['Boolean'];
  files?: InputMaybe<Array<FileUploadInput>>;
  privacyFlag: Scalars['Boolean'];
};

export type AggregatedSearchResult = {
  aggregation?: Maybe<SearchResultAggregation>;
};

export type Aircon = {
  __typename?: 'Aircon';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type ApiUserEntity = {
  __typename?: 'ApiUserEntity';
  _id: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  role: Scalars['String'];
};

export enum ApiUserRoles {
  Admin = 'ADMIN',
  User = 'USER'
}

export type Application = {
  birthDate: Scalars['Date'];
  birthName?: InputMaybe<Scalars['String']>;
  birthPlace: Scalars['String'];
  emailAddress?: InputMaybe<Scalars['String']>;
  expiryDate: Scalars['Date'];
  firstName: Scalars['String'];
  idNumberPass: Scalars['String'];
  idType: Scalars['String'];
  issuingAuthority: Scalars['String'];
  issuingDate: Scalars['Date'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  salutation: Scalars['String'];
  title: Scalars['String'];
};

export type AttributeGroup = {
  __typename?: 'AttributeGroup';
  attributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BankingInput = {
  additionalDocuments?: InputMaybe<AdditionalDocuments>;
  expensesIncome?: InputMaybe<ExpensesIncome>;
  householdJob?: InputMaybe<HouseholdJob>;
  personalData?: InputMaybe<PersonalData>;
};

export type BodyColor = {
  __typename?: 'BodyColor';
  displayName: Scalars['String'];
  hex?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type BookWorkshopServiceDealerInput = {
  city: Scalars['String'];
  contactPerson: Scalars['String'];
  country: Scalars['String'];
  houseNumber: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  street: Scalars['String'];
};

export type BookWorkshopServiceFormInput = {
  message: Scalars['String'];
  userEmail: Scalars['String'];
  userFirstName: Scalars['String'];
  userLastName: Scalars['String'];
  userPhone: Scalars['String'];
};

export type BookWorkshopServiceInput = {
  dealer: BookWorkshopServiceDealerInput;
  form: BookWorkshopServiceFormInput;
  product: BookWorkshopServiceProductInput;
  timeslot: BookWorkshopServiceTimeSlotInput;
  vehicle: BookWorkshopServiceVehicleInput;
};

export type BookWorkshopServiceProductInput = {
  name: Scalars['String'];
  price: Scalars['Float'];
  sku: Scalars['Int'];
};

export type BookWorkshopServiceTimeSlotInput = {
  requestDate: Scalars['Date'];
  requestTimeSlot: Scalars['String'];
};

export type BookWorkshopServiceVehicleInput = {
  fuelType: Scalars['String'];
  licencePlate: Scalars['String'];
  make: Scalars['String'];
  mileage: Scalars['Int'];
  model: Scalars['String'];
  registeredIn: Scalars['DateRegister'];
};

export type BrandAccessory = {
  __typename?: 'BrandAccessory';
  brand: Scalars['String'];
  distributorId: Scalars['String'];
};

export type BrandFilter = {
  makeName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  variantName?: InputMaybe<Scalars['String']>;
};

export type C2cCarInformationInput = {
  address: C2cLocationInput;
  description?: InputMaybe<Scalars['String']>;
  isFixedPrice: Scalars['Boolean'];
  isPrivateSeller: Scalars['Boolean'];
  mileage: Scalars['Int'];
  price: Scalars['Float'];
  vin: Scalars['String'];
};

export type C2cContactInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
};

export type C2cLocationInput = {
  city: Scalars['String'];
  geoCoordinates: GeoCoordinatesInput;
  zipCode: Scalars['String'];
};

export enum C2cStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Pending = 'PENDING'
}

export type C2cVehicleInput = {
  carInformation: C2cCarInformationInput;
  garageVehicleId: Scalars['Int'];
  images?: InputMaybe<Array<FileUploadInput>>;
};

export type C2cVehicleResponse = {
  __typename?: 'C2cVehicleResponse';
  garageVehicleId: Scalars['Int'];
  sku: Scalars['String'];
  status: C2cStatus;
  vehicleId: Scalars['String'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CareerInformation = {
  employedDate: Scalars['Date'];
  employedUntilDate?: InputMaybe<Scalars['Date']>;
  employerName: Scalars['String'];
  employmentType: Scalars['String'];
  hasPreviousEmployer: Scalars['Boolean'];
  jobPlace?: InputMaybe<Residence>;
  jobTitle: Scalars['String'];
  previousEmployerName?: InputMaybe<Scalars['String']>;
  previousJobPlace?: InputMaybe<Residence>;
  professionalGroup: Scalars['String'];
};

export type Cart = {
  __typename?: 'Cart';
  grandTotal?: Maybe<Scalars['Float']>;
  items: Array<CartItem>;
  monthlyPrice?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  taxTotal?: Maybe<Scalars['Float']>;
};

export type CartItem = {
  __typename?: 'CartItem';
  billingAddress?: Maybe<CustomerAddress>;
  dealer: Dealer;
  disabled?: Maybe<Scalars['Boolean']>;
  payment: CartItemPayment;
  product: Product;
  productType?: Maybe<ProductType>;
  quantity: Scalars['Int'];
  relatedProductSku?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
};

export type CartItemInput = {
  accessoryOptions?: InputMaybe<AccessoryOptionsInput>;
  billingAddress?: InputMaybe<CustomerAddressInput>;
  dealerId: Scalars['String'];
  paymentOptions?: InputMaybe<PaymentOptionsInput>;
  productType: ProductType;
  quantity: Scalars['Int'];
  relatedProductSku?: InputMaybe<Scalars['String']>;
  shipmentOptions?: InputMaybe<ShipmentOptionsInput>;
  sku: Scalars['String'];
  tradeInOptions?: InputMaybe<TradeInOptionsInput>;
};

export type CartItemPayment = {
  __typename?: 'CartItemPayment';
  bankSummary?: Maybe<Scalars['String']>;
  calculation?: Maybe<FinanceCalculationResult>;
  cashOption?: Maybe<CashOption>;
  monthlyPrice?: Maybe<Scalars['Float']>;
  paymentType?: Maybe<PaymentType>;
  price?: Maybe<Scalars['Float']>;
};

export enum CashOption {
  BankTransfer = 'BANK_TRANSFER',
  CreditCard = 'CREDIT_CARD',
  Dealer = 'DEALER',
  Payout = 'PAYOUT',
  Paypal = 'PAYPAL',
  Prepayment = 'PREPAYMENT',
  SepaMandate = 'SEPA_MANDATE'
}

export type CashOptionGroup = {
  __typename?: 'CashOptionGroup';
  cashOption: Array<CashOption>;
  sku: Scalars['String'];
};

export type Choice = {
  __typename?: 'Choice';
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  tooltip?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type Co2Efficiency = {
  __typename?: 'Co2Efficiency';
  displayName: Scalars['String'];
  name: Co2EfficiencyType;
};

export enum Co2EfficiencyType {
  A = 'A',
  Ap = 'AP',
  App = 'APP',
  Appp = 'APPP',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G'
}

export type Comfort = {
  __typename?: 'Comfort';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export enum CommunicationChannel {
  Callback = 'CALLBACK',
  Email = 'EMAIL',
  Videocall = 'VIDEOCALL'
}

export type Condition = {
  __typename?: 'Condition';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type ConfigurationElement = {
  __typename?: 'ConfigurationElement';
  grossAmount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  netAmount?: Maybe<Scalars['Float']>;
};

export type ConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
};

export type ContactDealerInput = {
  cashOption?: InputMaybe<CashOption>;
  communicationChannel: CommunicationChannel;
  contactMessage?: InputMaybe<Scalars['String']>;
  financeCalculationResult?: InputMaybe<FinanceCalculationResultInput>;
  paymentType?: InputMaybe<PaymentType>;
  productBankingPreApprovalDetails?: InputMaybe<PreApprovalInput>;
  requestTimeSlotOption?: InputMaybe<TimeSlotOptionInput>;
  userEmail: Scalars['String'];
  userFirstName: Scalars['String'];
  userLastName: Scalars['String'];
  userPhone?: InputMaybe<Scalars['String']>;
  vehiclePrice?: InputMaybe<Scalars['Int']>;
};

export type ContactDealerPayload = {
  __typename?: 'ContactDealerPayload';
  message?: Maybe<Scalars['String']>;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ContactTradeInInput = {
  contactMessage: Scalars['String'];
  requestDate: Scalars['Date'];
  userEmail: Scalars['String'];
  userFirstName: Scalars['String'];
  userLastName: Scalars['String'];
  userPhone: Scalars['String'];
};

export enum ContactType {
  CarRequest = 'CAR_REQUEST',
  ConfiguredVehicleRequest = 'CONFIGURED_VEHICLE_REQUEST',
  OrderVehicleRequest = 'ORDER_VEHICLE_REQUEST',
  TestDrive = 'TEST_DRIVE',
  TradeIn = 'TRADE_IN'
}

export type CreateCustomerInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type CreateInvalidVehicleUrlLogEntryInput = {
  integrationSlug: Scalars['String'];
  internalNumber: Scalars['String'];
  responseUrl: Scalars['String'];
};

export type CreateUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  role: ApiUserRoles;
};

export type Customer = {
  __typename?: 'Customer';
  addresses?: Maybe<Array<CustomerAddress>>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  salutation?: Maybe<Salutation>;
  updatedAt: Scalars['DateTime'];
};

export type CustomerAccessToken = {
  __typename?: 'CustomerAccessToken';
  accessToken: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  refreshToken: Scalars['String'];
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  additionalAddress?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  firstName: Scalars['String'];
  geoCoordinates?: Maybe<GeoCoordinates>;
  houseNumber: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isDefaultBilling?: Maybe<Scalars['Boolean']>;
  isDefaultShipping?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  salutation?: Maybe<Salutation>;
  street: Scalars['String'];
};

export type CustomerAddressInput = {
  additionalAddress?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  firstName: Scalars['String'];
  geoCoordinates?: InputMaybe<GeoCoordinatesInput>;
  houseNumber: Scalars['String'];
  isDefaultBilling?: InputMaybe<Scalars['Boolean']>;
  isDefaultShipping?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  salutation?: InputMaybe<Salutation>;
  street: Scalars['String'];
};

export type Dealer = {
  __typename?: 'Dealer';
  accessoriesProviders?: Maybe<Array<AccessoriesProvider>>;
  accessoryDealerId?: Maybe<Scalars['String']>;
  contactPerson?: Maybe<ContactPerson>;
  deliveryFee?: Maybe<Scalars['Float']>;
  distance?: Maybe<Scalars['Float']>;
  guaranteeUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']>;
  privacyPolicyLink?: Maybe<Scalars['String']>;
  retailOpeningHours?: Maybe<Array<OpeningHours>>;
  serviceOpeningHours?: Maybe<Array<OpeningHours>>;
  termsAndConditionsLink?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type DeliveryTime = {
  __typename?: 'DeliveryTime';
  maxWorkdays: Scalars['Int'];
  minWorkdays: Scalars['Int'];
};

export type Door = {
  __typename?: 'Door';
  displayName: Scalars['String'];
  name?: Maybe<DoorCount>;
};

export enum DoorCount {
  FourOrFive = 'FOUR_OR_FIVE',
  SixOrSeven = 'SIX_OR_SEVEN',
  TwoOrThree = 'TWO_OR_THREE'
}

export type DriveFacet = {
  __typename?: 'DriveFacet';
  gearBox?: Maybe<Array<Maybe<GearBox>>>;
  maxCubicCapacity: Scalars['Int'];
  power?: Maybe<Array<Maybe<PowerRange>>>;
};

export type DriveFilter = {
  gearBox?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxCubicCapacity?: InputMaybe<Scalars['Int']>;
  power?: InputMaybe<PowerRangeFilter>;
};

export type EmissionClass = {
  __typename?: 'EmissionClass';
  displayName: Scalars['String'];
  name: EmissionClassType;
};

export enum EmissionClassType {
  Euro1 = 'EURO1',
  Euro2 = 'EURO2',
  Euro3 = 'EURO3',
  Euro4 = 'EURO4',
  Euro5 = 'EURO5',
  Euro6 = 'EURO6',
  Euro6C = 'EURO6C',
  Euro6D = 'EURO6D',
  Euro6DTemp = 'EURO6D_TEMP'
}

export type EmissionFacet = {
  __typename?: 'EmissionFacet';
  co2Efficiency?: Maybe<Array<Maybe<Co2Efficiency>>>;
  emissionClass?: Maybe<Array<Maybe<EmissionClass>>>;
  emissionSticker?: Maybe<Array<Maybe<EmissionSticker>>>;
  maxCo2Emission: Scalars['Int'];
  minCo2Emission: Scalars['Int'];
};

export type EmissionFilter = {
  co2Efficiency?: InputMaybe<Co2EfficiencyType>;
  emissionClass?: InputMaybe<Array<InputMaybe<EmissionClassType>>>;
  emissionSticker?: InputMaybe<Array<InputMaybe<EmissionStickerType>>>;
  maxCo2Emission?: InputMaybe<Scalars['Int']>;
  particleFilter?: InputMaybe<Scalars['Boolean']>;
};

export type EmissionSticker = {
  __typename?: 'EmissionSticker';
  displayName: Scalars['String'];
  name: EmissionStickerType;
};

export enum EmissionStickerType {
  EmissionsstickerGreen = 'EMISSIONSSTICKER_GREEN',
  EmissionsstickerRed = 'EMISSIONSSTICKER_RED',
  EmissionsstickerYellow = 'EMISSIONSSTICKER_YELLOW'
}

export type Entertainment = {
  __typename?: 'Entertainment';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type Environment = {
  __typename?: 'Environment';
  co2Efficiency?: Maybe<Scalars['String']>;
  co2Emission?: Maybe<Scalars['Int']>;
  emissionClass?: Maybe<Scalars['String']>;
  emissionSticker?: Maybe<Scalars['String']>;
  fuelConsumptionCombined?: Maybe<Scalars['Float']>;
  fuelConsumptionExtraUrban?: Maybe<Scalars['Float']>;
  fuelConsumptionUrban?: Maybe<Scalars['Float']>;
  wltConsumption?: Maybe<Scalars['String']>;
  wltConsumptionElectric?: Maybe<Scalars['String']>;
  wltEmission?: Maybe<Scalars['Int']>;
};

export type Equipment = {
  __typename?: 'Equipment';
  aircon?: Maybe<Array<Maybe<Aircon>>>;
  comfort?: Maybe<Array<Maybe<Comfort>>>;
  entertainment?: Maybe<Array<Maybe<Entertainment>>>;
  security?: Maybe<Array<Maybe<Security>>>;
};

export type EquipmentFilter = {
  aircon?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  comfort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  entertainment?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  security?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ExpensesIncome = {
  bankName: Scalars['String'];
  deduction?: InputMaybe<Scalars['Int']>;
  iban: Scalars['String'];
  installment: Scalars['String'];
  maintenanceIncome?: InputMaybe<Scalars['Int']>;
  maintenanceObligations?: InputMaybe<Scalars['Int']>;
  mortgages?: InputMaybe<Scalars['Int']>;
  netIncome: Scalars['Int'];
  otherIncome?: InputMaybe<Scalars['Int']>;
  otherInformation?: InputMaybe<Scalars['Int']>;
  otherLoans?: InputMaybe<Scalars['Int']>;
  pension?: InputMaybe<Scalars['Int']>;
  privateHealthInsurance?: InputMaybe<Scalars['String']>;
  rentalIncome?: InputMaybe<Scalars['Int']>;
};

export type ExternalVehicleFilterOptions = {
  merchantUuids: Array<Scalars['String']>;
};

export type ExternalVehiclePageLink = {
  __typename?: 'ExternalVehiclePageLink';
  pdpUrl: Scalars['String'];
};

export type Facets = {
  __typename?: 'Facets';
  bodyColor?: Maybe<Array<Maybe<BodyColor>>>;
  drive?: Maybe<DriveFacet>;
  emission?: Maybe<EmissionFacet>;
  equipment?: Maybe<Equipment>;
  fuelType?: Maybe<FuelTypeFacet>;
  interior?: Maybe<InteriorFacet>;
  make?: Maybe<Array<Maybe<Make>>>;
  merchantUuids?: Maybe<Array<Maybe<MerchantFacet>>>;
  price?: Maybe<Array<Maybe<PriceRange>>>;
  vehicleConditions?: Maybe<VehicleConditionFacet>;
  vehicleType?: Maybe<VehicleTypeFacet>;
};

export type Feature = {
  __typename?: 'Feature';
  name: Scalars['String'];
};

export type FileUploadConfigResponse = {
  __typename?: 'FileUploadConfigResponse';
  configuration: UploadPolicy;
  url: Scalars['String'];
};

export type FileUploadInput = {
  original: Scalars['String'];
  path: Scalars['String'];
};

export type FinanceCalculationInput = {
  downPayment: Scalars['Float'];
  duration: Scalars['Int'];
  finalInstallment?: InputMaybe<Scalars['Float']>;
  hasFinalInstallment?: InputMaybe<Scalars['Boolean']>;
  mileage: Scalars['Int'];
};

export type FinanceCalculationResult = {
  __typename?: 'FinanceCalculationResult';
  downPayment?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Int']>;
  effectiveInterestRate?: Maybe<Scalars['Float']>;
  finalInstallment?: Maybe<Scalars['Float']>;
  hasFinalInstallment?: Maybe<Scalars['Boolean']>;
  mileage?: Maybe<Scalars['Int']>;
  monthlyInstallment: Scalars['Float'];
  netLoanAmount?: Maybe<Scalars['Float']>;
  nominalInterestRate?: Maybe<Scalars['Float']>;
  summary?: Maybe<Scalars['String']>;
  totalInterestAmount?: Maybe<Scalars['Float']>;
  totalRepaymentAmount?: Maybe<Scalars['Float']>;
  vehiclePrice?: Maybe<Scalars['Float']>;
};

export type FinanceCalculationResultInput = {
  downPayment?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Int']>;
  finalInstallment?: InputMaybe<Scalars['Float']>;
  mileage?: InputMaybe<Scalars['Int']>;
  monthlyInstallment: Scalars['Float'];
};

export type FinanceCalculatorOptions = {
  __typename?: 'FinanceCalculatorOptions';
  leasing?: Maybe<LeasingOptions>;
  loan?: Maybe<LoanOptions>;
};

export type FinanceCalculatorParameter = {
  __typename?: 'FinanceCalculatorParameter';
  default: Scalars['Float'];
  isActive?: Maybe<Scalars['Boolean']>;
  max: Scalars['Float'];
  min: Scalars['Float'];
  step?: Maybe<Scalars['Float']>;
};

export type FinanceToggleParameter = {
  __typename?: 'FinanceToggleParameter';
  default: Scalars['Boolean'];
  isActive?: Maybe<Scalars['Boolean']>;
};

export type FinancingDetail = {
  __typename?: 'FinancingDetail';
  duration?: Maybe<Scalars['Int']>;
  finalPayment: Scalars['Float'];
  mileage?: Maybe<Scalars['Int']>;
  monthlyRate: Scalars['Float'];
  prepayment: Scalars['Float'];
  summary?: Maybe<Scalars['String']>;
  type?: Maybe<PaymentType>;
};

export type FormInputType = {
  __typename?: 'FormInputType';
  choices?: Maybe<Array<Maybe<Choice>>>;
  label: Scalars['String'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  type: InputType;
};

export type FuelType = {
  __typename?: 'FuelType';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type FuelTypeFacet = {
  __typename?: 'FuelTypeFacet';
  fuelTypes?: Maybe<Array<Maybe<FuelType>>>;
  maxFuelConsumption: Scalars['Float'];
  maxPowerConsumption: Scalars['Float'];
};

export type FuelTypeFilter = {
  fuelType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxFuelConsumption?: InputMaybe<Scalars['Int']>;
  maxPowerConsumption?: InputMaybe<Scalars['Int']>;
};

export type GarageVehicle = {
  __typename?: 'GarageVehicle';
  body?: Maybe<Scalars['String']>;
  bodyType?: Maybe<Scalars['String']>;
  c2cAbstractId?: Maybe<Scalars['String']>;
  c2cId?: Maybe<Scalars['String']>;
  c2cStatus?: Maybe<C2cStatus>;
  color?: Maybe<Scalars['String']>;
  dealer?: Maybe<Dealer>;
  displacement?: Maybe<Scalars['String']>;
  doors?: Maybe<Scalars['Int']>;
  engine?: Maybe<Scalars['String']>;
  firstRegistration: Scalars['Date'];
  fuel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<ProductImage>;
  licencePlate?: Maybe<Scalars['String']>;
  make: Scalars['String'];
  mileage?: Maybe<Scalars['Int']>;
  model: Scalars['String'];
  powerHp?: Maybe<Scalars['Int']>;
  powerKw?: Maybe<Scalars['Int']>;
  powerPs?: Maybe<Scalars['Int']>;
  seats?: Maybe<Scalars['Int']>;
  services: Array<Service>;
  transmissionSteps?: Maybe<Scalars['String']>;
  transmissionSummary?: Maybe<Scalars['String']>;
  transmissionType?: Maybe<Scalars['String']>;
  trim?: Maybe<Scalars['String']>;
  valuation?: Maybe<GarageVehicleValuation>;
  vehicleEquipment?: Maybe<Array<Scalars['String']>>;
  vehicleFinalPrice?: Maybe<Scalars['Float']>;
  vehicleMaximalPrice?: Maybe<Scalars['Float']>;
  vehicleMinimalPrice?: Maybe<Scalars['Float']>;
  vehicleOptions?: Maybe<Array<VehicleOption>>;
  vin?: Maybe<Scalars['String']>;
  wheelDrive?: Maybe<Scalars['String']>;
};

export type GarageVehicleInput = {
  body?: InputMaybe<Scalars['String']>;
  bodyType?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['String']>;
  displacement?: InputMaybe<Scalars['String']>;
  doors?: InputMaybe<Scalars['Int']>;
  engine?: InputMaybe<Scalars['String']>;
  firstRegistration: Scalars['Date'];
  fuel?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<Scalars['ID']>>;
  licencePlate?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  mileage?: InputMaybe<Scalars['Int']>;
  model: Scalars['String'];
  powerHp?: InputMaybe<Scalars['Int']>;
  powerKw?: InputMaybe<Scalars['Int']>;
  powerPs?: InputMaybe<Scalars['Int']>;
  seats?: InputMaybe<Scalars['Int']>;
  transmissionSteps?: InputMaybe<Scalars['String']>;
  transmissionSummary?: InputMaybe<Scalars['String']>;
  transmissionType?: InputMaybe<Scalars['String']>;
  trim?: InputMaybe<Scalars['String']>;
  valuation?: InputMaybe<GarageVehicleValuationInput>;
  vehicleEquipment?: InputMaybe<Array<Scalars['String']>>;
  vehicleFinalPrice?: InputMaybe<Scalars['Float']>;
  vehicleMaximalPrice?: InputMaybe<Scalars['Float']>;
  vehicleMinimalPrice?: InputMaybe<Scalars['Float']>;
  vehicleOptions?: InputMaybe<Array<VehicleOptionInput>>;
  vin?: InputMaybe<Scalars['String']>;
  wheelDrive?: InputMaybe<Scalars['String']>;
};

export type GarageVehiclePriceHistory = {
  __typename?: 'GarageVehiclePriceHistory';
  valuationDate?: Maybe<Scalars['DateTime']>;
  vehicleFinalPrice?: Maybe<Scalars['Float']>;
  vehicleMaximalPrice?: Maybe<Scalars['Float']>;
  vehicleMinimalPrice?: Maybe<Scalars['Float']>;
};

export type GarageVehiclePriceHistoryInput = {
  valuationDate?: InputMaybe<Scalars['Date']>;
  vehicleFinalPrice?: InputMaybe<Scalars['Float']>;
  vehicleMaximalPrice?: InputMaybe<Scalars['Float']>;
  vehicleMinimalPrice?: InputMaybe<Scalars['Float']>;
};

export type GarageVehicleValuation = {
  __typename?: 'GarageVehicleValuation';
  equipmentIds?: Maybe<Array<Scalars['String']>>;
  priceHistory?: Maybe<Array<Maybe<GarageVehiclePriceHistory>>>;
  trimId?: Maybe<Scalars['Int']>;
  variantId?: Maybe<Scalars['Int']>;
};

export type GarageVehicleValuationInput = {
  equipmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priceHistory?: InputMaybe<Array<GarageVehiclePriceHistoryInput>>;
  trimId?: InputMaybe<Scalars['Int']>;
  variantId?: InputMaybe<Scalars['Int']>;
};

export type GearBox = {
  __typename?: 'GearBox';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type GeoCoordinates = {
  __typename?: 'GeoCoordinates';
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
};

export type GeoCoordinatesInput = {
  lat: Scalars['String'];
  lon: Scalars['String'];
};

export type HomeAddress = {
  country: Scalars['String'];
  currentResidence: Residence;
  previousResidence?: InputMaybe<Residence>;
  residenceDate: Scalars['Date'];
};

export type HourInterval = {
  __typename?: 'HourInterval';
  from?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  to?: Maybe<Scalars['String']>;
};

export type HouseholdInformation = {
  homeOwnership: Scalars['Boolean'];
  livingSituation: Scalars['String'];
  maritalStatus: Scalars['String'];
  nationality: Scalars['String'];
  numberOfChildren: Scalars['Int'];
  peopleInHousehold: Scalars['Int'];
  residencePermit?: InputMaybe<Scalars['String']>;
  residencePermitUntilDate?: InputMaybe<Scalars['Date']>;
};

export type HouseholdJob = {
  careerInformation?: InputMaybe<CareerInformation>;
  householdInformation?: InputMaybe<HouseholdInformation>;
};

export enum InputType {
  Rating = 'RATING',
  Select = 'SELECT',
  Toggle = 'TOGGLE'
}

export enum InsuranceOption {
  Gap = 'GAP',
  GapPlus = 'GAP_PLUS',
  Rsv = 'RSV',
  RsvPlus = 'RSV_PLUS'
}

export type Interior = {
  __typename?: 'Interior';
  interiorColor?: Maybe<Scalars['String']>;
  interiorType?: Maybe<Scalars['String']>;
};

export type InteriorColor = {
  __typename?: 'InteriorColor';
  displayName: Scalars['String'];
  hex: Scalars['String'];
  name: Scalars['String'];
};

export type InteriorFacet = {
  __typename?: 'InteriorFacet';
  interiorColor?: Maybe<Array<Maybe<InteriorColor>>>;
  interiorType?: Maybe<Array<Maybe<InteriorType>>>;
};

export type InteriorFilter = {
  interiorColor?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interiorType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type InteriorType = {
  __typename?: 'InteriorType';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type InvalidVehicleUrlLogEntryEntity = {
  __typename?: 'InvalidVehicleUrlLogEntryEntity';
  _id: Scalars['String'];
  integrationSlug: Scalars['String'];
  internalNumber: Scalars['String'];
  responseUrl: Scalars['String'];
};

export type LeasingCalculationInput = {
  downPayment: Scalars['Float'];
  duration: Scalars['Int'];
  mileage: Scalars['Int'];
};

export type LeasingOptions = {
  __typename?: 'LeasingOptions';
  downPayment: FinanceCalculatorParameter;
  duration: FinanceCalculatorParameter;
  legalText: Scalars['String'];
  mileage: FinanceCalculatorParameter;
};

export type LegalTextResponse = {
  __typename?: 'LegalTextResponse';
  legalNotice: Scalars['String'];
};

export type ListUsersInput = {
  limit: Scalars['Float'];
  offset: Scalars['Float'];
};

export type ListUsersResponse = {
  __typename?: 'ListUsersResponse';
  page: UserConnection;
  pageData?: Maybe<PageDataDto>;
};

export type LoanCalculationInput = {
  downPayment: Scalars['Float'];
  duration: Scalars['Int'];
  finalInstallment?: InputMaybe<Scalars['Float']>;
  hasFinalInstallment: Scalars['Boolean'];
  mileage: Scalars['Int'];
};

export type LoanOptions = {
  __typename?: 'LoanOptions';
  downPayment: FinanceCalculatorParameter;
  duration: FinanceCalculatorParameter;
  finalInstallment: FinanceCalculatorParameter;
  finalInstallmentToggle: FinanceToggleParameter;
  insuranceOptions?: Maybe<Array<Maybe<InsuranceOption>>>;
  legalText: Scalars['String'];
  mileage: FinanceCalculatorParameter;
};

export type Location = {
  __typename?: 'Location';
  additionalAddress?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  countryName?: Maybe<Scalars['String']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  houseNumber: Scalars['String'];
  street: Scalars['String'];
  zip: Scalars['String'];
};

export type LocationFilterInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  maxDistance?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type LoggedUserOutput = {
  __typename?: 'LoggedUserOutput';
  access_token: Scalars['String'];
};

export type LoginUserInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Make = {
  __typename?: 'Make';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type MerchantFacet = {
  __typename?: 'MerchantFacet';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type MerchantPortalResponse = {
  __typename?: 'MerchantPortalResponse';
  brandColor: Scalars['String'];
  brandColorContrast: Scalars['String'];
  dataPrivacyUrl: Scalars['String'];
  domain: Scalars['String'];
  imprintUrl: Scalars['String'];
  logo: Scalars['String'];
  make: Scalars['String'];
  merchantName: Scalars['String'];
  merchantOrigin: Scalars['String'];
  merchantUuids: Array<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  termsAndConditionsUrl: Scalars['String'];
  trackingId?: Maybe<Scalars['String']>;
};

export type Model = {
  __typename?: 'Model';
  displayName: Scalars['String'];
  name: Scalars['String'];
  subGroups?: Maybe<Array<Maybe<Model>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addBankingDetails?: Maybe<Scalars['Boolean']>;
  addC2cVehicle: C2cVehicleResponse;
  addCustomerAddress: CustomerAddress;
  addGarageVehicle: GarageVehicle;
  addToCart?: Maybe<Cart>;
  bookWorkshopService: Scalars['Boolean'];
  calculateLeasing: FinanceCalculationResult;
  calculateLoan: FinanceCalculationResult;
  calculatePreApproval: PreApprovalResult;
  checkout: Order;
  confirmCustomer: Scalars['Boolean'];
  contactC2c: Scalars['Boolean'];
  contactDealer: Scalars['Boolean'];
  createApiUser: ApiUserEntity;
  createCustomer: Customer;
  createCustomerAccessToken: CustomerAccessToken;
  createSystemConfig: SystemConfig;
  customerRecover: Scalars['Boolean'];
  customerReset: Scalars['Boolean'];
  deleteC2cVehicle: Scalars['Boolean'];
  deleteCustomer: Scalars['Boolean'];
  deleteCustomerAddress: Scalars['Boolean'];
  deleteFromCart?: Maybe<Cart>;
  deleteGarageVehicle?: Maybe<Scalars['Boolean']>;
  externalCalculateLeasing: FinanceCalculationResult;
  externalCalculateLoan: FinanceCalculationResult;
  loginUser: LoggedUserOutput;
  removeApiUser: Scalars['Boolean'];
  renewCustomerAccessToken: CustomerAccessToken;
  requestTestDrive: Scalars['Boolean'];
  requestVehicle: Scalars['Boolean'];
  resendCustomerActivationToken: Scalars['Boolean'];
  tradeInContactDealer: Scalars['Boolean'];
  tradeInInputStandaloneJourney: TradeInJourneyResponse;
  tradeInInputWidgetJourney: TradeInJourneyResponse;
  tradeInVariationValuation?: Maybe<TradeInValuationPrice>;
  updateApiUser: ApiUserEntity;
  updateCartItem?: Maybe<Cart>;
  updateCustomer: Customer;
  updateCustomerAddress: CustomerAddress;
  updateCustomerPassword: Scalars['Boolean'];
  updateGarageVehicle: GarageVehicle;
  updateSystemConfig: SystemConfig;
};


export type MutationAddBankingDetailsArgs = {
  input?: InputMaybe<BankingInput>;
  paymentGroupUuid?: InputMaybe<Scalars['String']>;
};


export type MutationAddC2cVehicleArgs = {
  input?: InputMaybe<C2cVehicleInput>;
};


export type MutationAddCustomerAddressArgs = {
  input: CustomerAddressInput;
};


export type MutationAddGarageVehicleArgs = {
  input?: InputMaybe<GarageVehicleInput>;
};


export type MutationAddToCartArgs = {
  input: AddToCartInput;
};


export type MutationBookWorkshopServiceArgs = {
  input?: InputMaybe<BookWorkshopServiceInput>;
};


export type MutationCalculateLeasingArgs = {
  configuratorId?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<LeasingCalculationInput>;
  vehicleId?: InputMaybe<Scalars['String']>;
};


export type MutationCalculateLoanArgs = {
  configuratorId?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<LoanCalculationInput>;
  vehicleId?: InputMaybe<Scalars['String']>;
};


export type MutationCalculatePreApprovalArgs = {
  input?: InputMaybe<PreApprovalInput>;
  vehicleId?: InputMaybe<Scalars['String']>;
};


export type MutationConfirmCustomerArgs = {
  registrationKey: Scalars['String'];
};


export type MutationContactC2cArgs = {
  c2cId?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<C2cContactInput>;
};


export type MutationContactDealerArgs = {
  configuratorId?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['String']>;
  formData?: InputMaybe<ContactDealerInput>;
  vehicleId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateApiUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateCustomerArgs = {
  input?: InputMaybe<CreateCustomerInput>;
};


export type MutationCreateCustomerAccessTokenArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCreateSystemConfigArgs = {
  systemConfigInput?: InputMaybe<SystemConfigInput>;
};


export type MutationCustomerRecoverArgs = {
  email: Scalars['String'];
};


export type MutationCustomerResetArgs = {
  password: Scalars['String'];
  passwordConfirm: Scalars['String'];
  passwordHash: Scalars['String'];
};


export type MutationDeleteC2cVehicleArgs = {
  c2cId: Scalars['String'];
};


export type MutationDeleteCustomerArgs = {
  userId: Scalars['String'];
};


export type MutationDeleteCustomerAddressArgs = {
  customerAddressId: Scalars['String'];
};


export type MutationDeleteFromCartArgs = {
  sku?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteGarageVehicleArgs = {
  id: Scalars['ID'];
};


export type MutationExternalCalculateLeasingArgs = {
  input?: InputMaybe<LeasingCalculationInput>;
  vehicleId?: InputMaybe<Scalars['String']>;
};


export type MutationExternalCalculateLoanArgs = {
  input?: InputMaybe<LoanCalculationInput>;
  vehicleId?: InputMaybe<Scalars['String']>;
};


export type MutationLoginUserArgs = {
  loginUserInput: LoginUserInput;
};


export type MutationRemoveApiUserArgs = {
  _id: Scalars['String'];
};


export type MutationRenewCustomerAccessTokenArgs = {
  customerRefreshToken: Scalars['String'];
};


export type MutationRequestTestDriveArgs = {
  configuratorId?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['String']>;
  formData?: InputMaybe<RequestTestDriveInput>;
  vehicleId?: InputMaybe<Scalars['String']>;
};


export type MutationRequestVehicleArgs = {
  configuratorId?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['String']>;
  formData?: InputMaybe<RequestVehicleInput>;
  sku?: InputMaybe<Scalars['String']>;
};


export type MutationResendCustomerActivationTokenArgs = {
  input?: InputMaybe<Scalars['String']>;
};


export type MutationTradeInContactDealerArgs = {
  dealerId?: InputMaybe<Scalars['String']>;
  formData?: InputMaybe<ContactTradeInInput>;
  garageVehicleId?: InputMaybe<Scalars['String']>;
};


export type MutationTradeInInputStandaloneJourneyArgs = {
  input?: InputMaybe<TradeInStandaloneJourneyInput>;
};


export type MutationTradeInInputWidgetJourneyArgs = {
  input?: InputMaybe<TradeInWidgetJourneyInput>;
};


export type MutationTradeInVariationValuationArgs = {
  input?: InputMaybe<TradeInVariantValuationInput>;
};


export type MutationUpdateApiUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateCartItemArgs = {
  input?: InputMaybe<CartItemInput>;
  sku?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCustomerArgs = {
  input?: InputMaybe<UpdateCustomerInput>;
};


export type MutationUpdateCustomerAddressArgs = {
  customerAddressId: Scalars['String'];
  input: CustomerAddressInput;
};


export type MutationUpdateCustomerPasswordArgs = {
  input?: InputMaybe<UpdateCustomerPasswordInput>;
};


export type MutationUpdateGarageVehicleArgs = {
  id: Scalars['ID'];
  input?: InputMaybe<GarageVehicleInput>;
};


export type MutationUpdateSystemConfigArgs = {
  systemConfigInput?: InputMaybe<SystemConfigInput>;
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  day?: Maybe<Weekday>;
  from?: Maybe<Scalars['String']>;
  hasIntervals?: Maybe<Scalars['Boolean']>;
  hourIntervals?: Maybe<Array<HourInterval>>;
  isActive?: Maybe<Scalars['Boolean']>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<OpeningHoursType>;
};

export enum OpeningHoursType {
  Sale = 'SALE',
  Service = 'SERVICE'
}

export type Order = {
  __typename?: 'Order';
  id: Scalars['ID'];
  orderDate: Scalars['DateTime'];
  orderItemSummaries?: Maybe<Array<OrderItemSummary>>;
  paymentGroups: Array<PaymentGroup>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  billingAddress: CustomerAddress;
  dealer?: Maybe<Dealer>;
  payment: CartItemPayment;
  product: Product;
  productType: ProductType;
  relatedProductSku?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
};

export enum OrderItemStatus {
  Cancelled = 'CANCELLED',
  PaymentDetailsInProgress = 'PAYMENT_DETAILS_IN_PROGRESS',
  WaitingForPaymentDetails = 'WAITING_FOR_PAYMENT_DETAILS'
}

export type OrderItemSummary = {
  __typename?: 'OrderItemSummary';
  image?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  productType?: Maybe<ProductType>;
  title: Scalars['String'];
};

export type OrderPaymentUrl = {
  __typename?: 'OrderPaymentUrl';
  isExternal?: Maybe<Scalars['Boolean']>;
  type?: Maybe<PaymentUrlType>;
  url?: Maybe<Scalars['String']>;
};

export type PageDataDto = {
  __typename?: 'PageDataDto';
  count: Scalars['Float'];
  limit: Scalars['Float'];
  offset: Scalars['Float'];
};

export type PaymentGroup = {
  __typename?: 'PaymentGroup';
  bankName?: Maybe<Scalars['String']>;
  cashOption?: Maybe<CashOption>;
  orderItems: Array<OrderItem>;
  paymentType?: Maybe<PaymentType>;
  paymentUrl?: Maybe<OrderPaymentUrl>;
  priceSum: Scalars['Float'];
  status: OrderItemStatus;
};

export type PaymentOptionsInput = {
  cashOption?: InputMaybe<CashOption>;
  financeCalculation?: InputMaybe<FinanceCalculationInput>;
  paymentType: PaymentType;
};

export enum PaymentType {
  CashRange = 'CASH_RANGE',
  LeasingRateRange = 'LEASING_RATE_RANGE',
  LoanRateRange = 'LOAN_RATE_RANGE'
}

export enum PaymentUrlType {
  Adyen = 'ADYEN',
  BankingRequest = 'BANKING_REQUEST'
}

export type PersonalData = {
  application?: InputMaybe<Application>;
  homeAddress?: InputMaybe<HomeAddress>;
};

export type PowerRange = {
  __typename?: 'PowerRange';
  key: PowerType;
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type PowerRangeFilter = {
  key: PowerType;
  max: Scalars['Int'];
  min?: InputMaybe<Scalars['Int']>;
};

export enum PowerType {
  Kw = 'KW',
  Ps = 'PS'
}

export type PreApprovalInput = {
  bankingType: PaymentType;
  existingMonthlyInstallmentsSum: Scalars['Float'];
  finalInstallment: Scalars['Float'];
  hasNoInsolvencyProceedings: Scalars['Boolean'];
  hasNoNegativeCreditReports: Scalars['Boolean'];
  isNotABusinessOwner: Scalars['Boolean'];
  isVehiclePrivatelyUsed: Scalars['Boolean'];
  monthlyNetIncome: Scalars['Float'];
  otherMonthlyExpensesSum: Scalars['Float'];
  peopleInHousehold: Scalars['Int'];
  purchasePrice: Scalars['Float'];
  term: Scalars['Int'];
};

export type PreApprovalResult = {
  __typename?: 'PreApprovalResult';
  isPreApproved: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type PriceFilter = {
  key?: InputMaybe<PaymentType>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

export type PriceRange = {
  __typename?: 'PriceRange';
  key: Scalars['String'];
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export type Product = Accessory | Service | Shipment | TradeInVehicle | Vehicle;

export type ProductImage = {
  __typename?: 'ProductImage';
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export enum ProductType {
  Accessory = 'ACCESSORY',
  AccessoryStandAlone = 'ACCESSORY_STAND_ALONE',
  Service = 'SERVICE',
  Shipment = 'SHIPMENT',
  TradeInVehicle = 'TRADE_IN_VEHICLE',
  Vehicle = 'VEHICLE'
}

export type Query = {
  __typename?: 'Query';
  accessories?: Maybe<Array<Accessory>>;
  accessoryBrands: Array<AccessoryBrand>;
  accessoryById: AccessoryDetails;
  accessoryCategories?: Maybe<Array<AccessoryCategory>>;
  accessoryModelsVariants: Array<AccessoryModelVariants>;
  accessoryPriceDetails: AccessoryPriceDetails;
  accessorySearch?: Maybe<Array<Accessory>>;
  apiUser: ApiUserEntity;
  cart?: Maybe<Cart>;
  checkFeatureEnabled: Scalars['Boolean'];
  checkoutCashOptions: Array<CashOptionGroup>;
  checkoutServices: Array<Service>;
  checkoutShippingOptions: Array<Shipment>;
  customer?: Maybe<Customer>;
  enabledFeatures?: Maybe<Array<Feature>>;
  externalVehicleUrlByInternalNumber?: Maybe<ExternalVehiclePageLink>;
  externalVehiclesByMerchant?: Maybe<VehicleSearchResult>;
  facets?: Maybe<Facets>;
  fileUploadConfig: FileUploadConfigResponse;
  garageVehicles: Array<GarageVehicle>;
  getStory?: Maybe<Scalars['String']>;
  getWhiteLabelConfig?: Maybe<WhiteLabelResponse>;
  globalMakes: Array<Make>;
  globalModels: Array<Model>;
  listApiUsers?: Maybe<Array<ApiUserEntity>>;
  makes: Array<Maybe<Make>>;
  models?: Maybe<Array<Maybe<Model>>>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  searchConfigurableCarsDealers: Array<Dealer>;
  searchDealers: Array<Dealer>;
  tradeInForm?: Maybe<TradeInFormResponse>;
  variants?: Maybe<Array<Maybe<Variant>>>;
  vehicleById?: Maybe<Vehicle>;
  vehicleLegalText?: Maybe<LegalTextResponse>;
  vehicles?: Maybe<VehicleSearchResult>;
  workshopServiceAvailableDates?: Maybe<Array<WorkshopServiceAvailableDay>>;
  workshopServiceCategories?: Maybe<Array<Maybe<WorkshopServiceCategory>>>;
  workshopServiceLocationFinder: Array<Service>;
};


export type QueryAccessoriesArgs = {
  filter: AccessoryFilterOptions;
  sorting?: InputMaybe<AccessorySortingOptions>;
};


export type QueryAccessoryByIdArgs = {
  accessoryId: Scalars['String'];
  filter: AccessoryFilterOptions;
};


export type QueryAccessoryCategoriesArgs = {
  filter: AccessoryFilterOptions;
};


export type QueryAccessoryModelsVariantsArgs = {
  distributorId: Scalars['String'];
};


export type QueryAccessoryPriceDetailsArgs = {
  dealerId: Scalars['String'];
  productId: Scalars['String'];
};


export type QueryAccessorySearchArgs = {
  filter: AccessorySearchOptions;
  paging?: InputMaybe<AccessoryPaginationOptions>;
  sorting?: InputMaybe<AccessorySortingOptions>;
};


export type QueryApiUserArgs = {
  _id: Scalars['String'];
};


export type QueryCheckFeatureEnabledArgs = {
  featureKey: Scalars['String'];
};


export type QueryCheckoutServicesArgs = {
  sku: Scalars['String'];
};


export type QueryCheckoutShippingOptionsArgs = {
  sku: Scalars['String'];
};


export type QueryExternalVehicleUrlByInternalNumberArgs = {
  integrationSlug: Scalars['String'];
  internalNumber: Scalars['String'];
  returnUrl?: InputMaybe<Scalars['String']>;
};


export type QueryExternalVehiclesByMerchantArgs = {
  filter?: InputMaybe<ExternalVehicleFilterOptions>;
  pager?: InputMaybe<SearchResultPager>;
  sorting?: InputMaybe<VehicleSortingOptions>;
};


export type QueryFacetsArgs = {
  origin?: InputMaybe<Scalars['String']>;
};


export type QueryGetStoryArgs = {
  environment?: InputMaybe<WhiteLabelConfigEnvironment>;
  integrationSlug?: InputMaybe<Scalars['String']>;
  pageSlug?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<StoryBlokVersion>;
};


export type QueryGetWhiteLabelConfigArgs = {
  environment?: InputMaybe<WhiteLabelConfigEnvironment>;
  integrationSlug: Scalars['String'];
  pageSlug?: InputMaybe<Scalars['String']>;
  skipStoryBlok?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<StoryBlokVersion>;
};


export type QueryGlobalModelsArgs = {
  make: Scalars['String'];
};


export type QueryListApiUsersArgs = {
  listUsersInput?: InputMaybe<ListUsersInput>;
};


export type QueryModelsArgs = {
  makeName: Scalars['String'];
};


export type QueryOrderArgs = {
  orderId: Scalars['String'];
};


export type QuerySearchConfigurableCarsDealersArgs = {
  filter?: InputMaybe<SearchConfigurableCarsDealersFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchDealersArgs = {
  filter?: InputMaybe<SearchDealersFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryTradeInFormArgs = {
  brand?: InputMaybe<Scalars['String']>;
  merchantUuid?: InputMaybe<Scalars['String']>;
};


export type QueryVariantsArgs = {
  makeName: Scalars['String'];
  modelName: Scalars['String'];
};


export type QueryVehicleByIdArgs = {
  configuratorId?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['String']>;
  vehicleId: Scalars['String'];
};


export type QueryVehicleLegalTextArgs = {
  sku: Scalars['String'];
};


export type QueryVehiclesArgs = {
  filter?: InputMaybe<VehicleFilterOptions>;
  pager?: InputMaybe<SearchResultPager>;
  sorting?: InputMaybe<VehicleSortingOptions>;
};


export type QueryWorkshopServiceAvailableDatesArgs = {
  date: Scalars['String'];
  dealerId: Scalars['String'];
};


export type QueryWorkshopServiceLocationFinderArgs = {
  input: WorkshopServiceLocationFinderInput;
};

export type RequestTestDriveInput = {
  cashOption?: InputMaybe<CashOption>;
  contactMessage?: InputMaybe<Scalars['String']>;
  financeCalculationResult?: InputMaybe<FinanceCalculationResultInput>;
  paymentType?: InputMaybe<PaymentType>;
  requestTimeSlotOptions?: InputMaybe<Array<InputMaybe<TimeSlotOptionInput>>>;
  userEmail: Scalars['String'];
  userFirstName: Scalars['String'];
  userLastName: Scalars['String'];
  userPhone?: InputMaybe<Scalars['String']>;
};

export type RequestTestDrivePayload = {
  __typename?: 'RequestTestDrivePayload';
  message?: Maybe<Scalars['String']>;
};

export type RequestVehicleInput = {
  cashOption?: InputMaybe<CashOption>;
  contactMessage?: InputMaybe<Scalars['String']>;
  contactType?: InputMaybe<ContactType>;
  financeCalculationResult?: InputMaybe<FinanceCalculationResultInput>;
  newsletterAgreement?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<PaymentType>;
  userEmail: Scalars['String'];
  userFirstName: Scalars['String'];
  userLastName: Scalars['String'];
  userPhone?: InputMaybe<Scalars['String']>;
  vehiclePrice?: InputMaybe<Scalars['Int']>;
};

export type Residence = {
  city: Scalars['String'];
  street: Scalars['String'];
  streetNumber: Scalars['String'];
  zipCode: Scalars['Int'];
};

export enum Salutation {
  Diverse = 'DIVERSE',
  Mr = 'MR',
  Mrs = 'MRS'
}

export type SearchConfigurableCarsDealersFilterInput = {
  geoCoordinates: GeoCoordinatesInput;
  make?: InputMaybe<Scalars['String']>;
  maxDistance?: InputMaybe<Scalars['Int']>;
};

export type SearchDealersAccessoryFilterInput = {
  distributorDealerId: Scalars['String'];
  productId: Scalars['String'];
};

export type SearchDealersFilterInput = {
  accessory?: InputMaybe<SearchDealersAccessoryFilterInput>;
  geoCoordinates: GeoCoordinatesInput;
  make?: InputMaybe<Scalars['String']>;
  maxDistance?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<SearchDealersProductFilterInput>;
};

export type SearchDealersProductFilterInput = {
  dealerId: Scalars['String'];
  sku: Scalars['String'];
};

export type SearchResultAggregation = {
  __typename?: 'SearchResultAggregation';
  count?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type SearchResultPager = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type Security = {
  __typename?: 'Security';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type Service = {
  __typename?: 'Service';
  abstractProductSku?: Maybe<Scalars['String']>;
  dealer?: Maybe<Dealer>;
  description?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<ProductImage>>>;
  price?: Maybe<Scalars['Float']>;
  sku: Scalars['ID'];
  title: Scalars['String'];
};

export type ServicePriceCalculationInput = {
  dealerId: Scalars['String'];
  fuelType: Scalars['String'];
  make: Scalars['String'];
  mileage: Scalars['Int'];
  model: Scalars['String'];
  registeredIn: Scalars['DateRegister'];
  sku: Scalars['ID'];
};

export type Shipment = {
  __typename?: 'Shipment';
  customerAddressId?: Maybe<Scalars['String']>;
  dealerAddressId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  priceDimension?: Maybe<Scalars['String']>;
  shipmentDate?: Maybe<Scalars['Date']>;
  shipmentTimeSlot?: Maybe<TimeSlot>;
  shippingAddress?: Maybe<CustomerAddress>;
  shippingAddressOptions?: Maybe<Array<ShippingAddressOption>>;
  shippingType: ShippingType;
  sku: Scalars['ID'];
  title: Scalars['String'];
};

export type ShipmentOptionsInput = {
  dateOption?: InputMaybe<TimeSlotOptionInput>;
  destinationDealerId?: InputMaybe<Scalars['String']>;
  shippingAddressId?: InputMaybe<Scalars['String']>;
};

export type ShippingAddressOption = {
  __typename?: 'ShippingAddressOption';
  addressId: Scalars['String'];
  price: Scalars['Float'];
  roadDistance: Scalars['Float'];
};

export enum ShippingType {
  AccessoryDelivery = 'ACCESSORY_DELIVERY',
  AccessoryPickUp = 'ACCESSORY_PICK_UP',
  AccessoryPickUpWithInstallation = 'ACCESSORY_PICK_UP_WITH_INSTALLATION',
  Delivery = 'DELIVERY',
  DeliveryToDealer = 'DELIVERY_TO_DEALER',
  PickUp = 'PICK_UP'
}

export enum SortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum StoryBlokVersion {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type SystemConfig = {
  __typename?: 'SystemConfig';
  _id: Scalars['String'];
  logInvalidVehicleUrls: Scalars['Boolean'];
};

export type SystemConfigInput = {
  logInvalidVehicleUrls: Scalars['Boolean'];
};

export enum TimeSlot {
  Afternoon = 'AFTERNOON',
  Morning = 'MORNING',
  Noon = 'NOON'
}

export type TimeSlotOptionInput = {
  requestDate: Scalars['Date'];
  requestTimeSlot?: InputMaybe<TimeSlot>;
};

export type TradeInAccidentHistoryInput = {
  accidentDetails?: InputMaybe<Scalars['String']>;
  isDamagedCar?: InputMaybe<Scalars['Boolean']>;
  isRepairedCar?: InputMaybe<Scalars['Boolean']>;
};

export type TradeInCustomerJourney = {
  __typename?: 'TradeInCustomerJourney';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  isExistingCustomerForMerchant?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  salutation?: Maybe<Scalars['String']>;
};

export type TradeInCustomerJourneyInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  isExistingCustomerForMerchant?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
};

export type TradeInFormResponse = {
  __typename?: 'TradeInFormResponse';
  form?: Maybe<Array<Maybe<FormInputType>>>;
  widgetConfiguration?: Maybe<WidgetConfiguration>;
};

export type TradeInJourneyResponse = {
  __typename?: 'TradeInJourneyResponse';
  customer: TradeInCustomerJourney;
  merchant: TradeInMerchantJourney;
  mode: TradeInMode;
  options: Array<TradeInOptionJourney>;
  typeOfSell: TradeInTypeOfSell;
  valuation: TradeInValuationJourney;
  vehicle: TradeInVehicleJourney;
};

export type TradeInMerchantJourney = {
  __typename?: 'TradeInMerchantJourney';
  uuid: Scalars['String'];
};

export enum TradeInMode {
  Checkout = 'CHECKOUT',
  Standalone = 'STANDALONE',
  Widget = 'WIDGET'
}

export type TradeInOptionJourney = {
  __typename?: 'TradeInOptionJourney';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type TradeInOptionsInput = {
  garageVehicleId: Scalars['Int'];
};

export type TradeInStandaloneJourneyInput = {
  customer: TradeInCustomerJourneyInput;
  garageVehicleId: Scalars['Int'];
  merchantUuid: Scalars['String'];
  mode: TradeInMode;
  options: Array<TradeInVehicleOptionInput>;
  typeOfSell: TradeInTypeOfSell;
};

export enum TradeInTypeOfSell {
  Company = 'COMPANY',
  Private = 'PRIVATE'
}

export type TradeInValuationJourney = {
  __typename?: 'TradeInValuationJourney';
  finalPrice: Scalars['Float'];
  maximalPrice: Scalars['Float'];
  minimalPrice: Scalars['Float'];
};

export type TradeInValuationPrice = {
  __typename?: 'TradeInValuationPrice';
  finalPrice: Scalars['Float'];
  maximalPrice: Scalars['Float'];
  minimalPrice: Scalars['Float'];
};

export type TradeInValuationPriceInput = {
  finalPrice: Scalars['Float'];
  maximalPrice: Scalars['Float'];
  minimalPrice: Scalars['Float'];
};

export type TradeInVariantValuationInput = {
  dealerId?: InputMaybe<Scalars['String']>;
  firstRegistration: Scalars['Date'];
  mileage: Scalars['Int'];
  seats?: InputMaybe<Scalars['Int']>;
  tracer?: InputMaybe<Scalars['String']>;
  trimId?: InputMaybe<Scalars['Int']>;
  variantId: Scalars['Int'];
  vehicleOptions: Array<VehicleOptionInput>;
  zip?: InputMaybe<Scalars['String']>;
};

export type TradeInVehicle = {
  __typename?: 'TradeInVehicle';
  body?: Maybe<Scalars['String']>;
  bodyType?: Maybe<Scalars['String']>;
  displacement?: Maybe<Scalars['String']>;
  doors?: Maybe<Scalars['Int']>;
  engine?: Maybe<Scalars['String']>;
  firstRegistration: Scalars['Date'];
  fuel?: Maybe<Scalars['String']>;
  garageVehicleId: Scalars['Int'];
  images?: Maybe<Array<Maybe<ProductImage>>>;
  licencePlate?: Maybe<Scalars['String']>;
  make: Scalars['String'];
  mileage?: Maybe<Scalars['Int']>;
  model: Scalars['String'];
  powerHp?: Maybe<Scalars['Int']>;
  powerKw?: Maybe<Scalars['Int']>;
  powerPs?: Maybe<Scalars['Int']>;
  seats?: Maybe<Scalars['Int']>;
  sku: Scalars['ID'];
  title: Scalars['String'];
  transmissionSteps?: Maybe<Scalars['String']>;
  transmissionSummary?: Maybe<Scalars['String']>;
  transmissionType?: Maybe<Scalars['String']>;
  trim?: Maybe<Scalars['String']>;
  valuation?: Maybe<GarageVehicleValuation>;
  vehicleEquipment?: Maybe<Array<Maybe<Scalars['String']>>>;
  vehicleFinalPrice?: Maybe<Scalars['Float']>;
  vehicleMaximalPrice?: Maybe<Scalars['Float']>;
  vehicleMinimalPrice?: Maybe<Scalars['Float']>;
  vehicleOptions?: Maybe<Array<Maybe<VehicleOption>>>;
  vin?: Maybe<Scalars['String']>;
  wheelDrive?: Maybe<Scalars['String']>;
};

export type TradeInVehicleAccidentHistoryJourney = {
  __typename?: 'TradeInVehicleAccidentHistoryJourney';
  accidentDetails?: Maybe<Scalars['String']>;
  isDamagedCar?: Maybe<Scalars['Boolean']>;
  isRepairedCar?: Maybe<Scalars['Boolean']>;
};

export type TradeInVehicleCustomerImagesInput = {
  originalName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
};

export type TradeInVehicleCustomerImagesJourney = {
  __typename?: 'TradeInVehicleCustomerImagesJourney';
  originalName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type TradeInVehicleInput = {
  accidentHistory?: InputMaybe<TradeInAccidentHistoryInput>;
  body?: InputMaybe<Scalars['String']>;
  bodyType?: InputMaybe<Scalars['String']>;
  brand: Scalars['String'];
  customerImages?: InputMaybe<Array<InputMaybe<TradeInVehicleCustomerImagesInput>>>;
  displacement?: InputMaybe<Scalars['String']>;
  doors?: InputMaybe<Scalars['Int']>;
  engine?: InputMaybe<Scalars['String']>;
  fuelType?: InputMaybe<Scalars['String']>;
  initialRegistrationDate: Scalars['Date'];
  isServiceBookExists?: InputMaybe<Scalars['Boolean']>;
  licencePlate?: InputMaybe<Scalars['String']>;
  mileage: Scalars['Int'];
  model: Scalars['String'];
  numberOfOwners?: InputMaybe<Scalars['String']>;
  opticalCondition?: InputMaybe<Scalars['String']>;
  powerHp?: InputMaybe<Scalars['Int']>;
  powerKw?: InputMaybe<Scalars['Int']>;
  powerPs?: InputMaybe<Scalars['Int']>;
  seats?: InputMaybe<Scalars['Int']>;
  technicalCondition?: InputMaybe<Scalars['String']>;
  tracerId?: InputMaybe<Scalars['String']>;
  transmissionSteps?: InputMaybe<Scalars['String']>;
  transmissionSummary?: InputMaybe<Scalars['String']>;
  transmissionType?: InputMaybe<Scalars['String']>;
  trimId?: InputMaybe<Scalars['Int']>;
  trimLevel?: InputMaybe<Scalars['String']>;
  variantId: Scalars['Int'];
  vin?: InputMaybe<Scalars['String']>;
  wheelDrive?: InputMaybe<Scalars['String']>;
};

export type TradeInVehicleJourney = {
  __typename?: 'TradeInVehicleJourney';
  accidentHistory?: Maybe<TradeInVehicleAccidentHistoryJourney>;
  body?: Maybe<Scalars['String']>;
  bodyType?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  customerImages?: Maybe<Array<Maybe<TradeInVehicleCustomerImagesJourney>>>;
  displacement?: Maybe<Scalars['String']>;
  doors?: Maybe<Scalars['Int']>;
  engine?: Maybe<Scalars['String']>;
  fuelType?: Maybe<Scalars['String']>;
  garageVehicleId?: Maybe<Scalars['Int']>;
  initialRegistrationDate?: Maybe<Scalars['String']>;
  isServiceBookExists?: Maybe<Scalars['Boolean']>;
  licencePlate?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  numberOfOwners?: Maybe<Scalars['String']>;
  opticalCondition?: Maybe<Scalars['String']>;
  powerHp?: Maybe<Scalars['Int']>;
  powerKw?: Maybe<Scalars['Int']>;
  powerPs?: Maybe<Scalars['Int']>;
  seats?: Maybe<Scalars['Int']>;
  technicalCondition?: Maybe<Scalars['String']>;
  tracerId?: Maybe<Scalars['String']>;
  transmissionSteps?: Maybe<Scalars['String']>;
  transmissionSummary?: Maybe<Scalars['String']>;
  transmissionType?: Maybe<Scalars['String']>;
  trimId?: Maybe<Scalars['Int']>;
  trimLevel?: Maybe<Scalars['String']>;
  variantId?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
  wheelDrive?: Maybe<Scalars['String']>;
};

export type TradeInVehicleOptionInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type TradeInWidgetJourneyInput = {
  customer: TradeInCustomerJourneyInput;
  merchantBrand?: InputMaybe<Scalars['String']>;
  merchantUuid: Scalars['String'];
  mode: TradeInMode;
  options: Array<TradeInVehicleOptionInput>;
  typeOfSell: TradeInTypeOfSell;
  vehicle: TradeInVehicleInput;
};

export type UpdateCustomerInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerPasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirm: Scalars['String'];
  userId: Scalars['String'];
};

export type UpdateUserInput = {
  _id: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<ApiUserRoles>;
};

export type UploadPolicy = {
  __typename?: 'UploadPolicy';
  algorithm: Scalars['String'];
  credentials: Scalars['String'];
  date: Scalars['String'];
  key: Scalars['String'];
  policy: Scalars['String'];
  signature: Scalars['String'];
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges?: Maybe<Array<UserEdge>>;
  pageInfo?: Maybe<UserPageInfo>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ApiUserEntity>;
};

export type UserPageInfo = {
  __typename?: 'UserPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Variant = {
  __typename?: 'Variant';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type Vehicle = {
  __typename?: 'Vehicle';
  accessoryProviders?: Maybe<Array<AccessoryProvider>>;
  added?: Maybe<Scalars['DateTime']>;
  attributeGroups?: Maybe<Array<Maybe<AttributeGroup>>>;
  bodyColor?: Maybe<Scalars['String']>;
  bodyDesign?: Maybe<Scalars['String']>;
  cashOptions: Array<CashOption>;
  co2Class?: Maybe<Scalars['String']>;
  co2ClassDischargedBatteryWltp?: Maybe<Scalars['String']>;
  co2ClassWltpWhenBatteryDischarged?: Maybe<Scalars['String']>;
  co2EmissionsWltpWhenBatteryDischarged?: Maybe<Scalars['Float']>;
  combinedFuelConsumptionWltpBatteryDischarged?: Maybe<Scalars['Float']>;
  configurationElements?: Maybe<Array<Maybe<ConfigurationElement>>>;
  consumption?: Maybe<Scalars['Float']>;
  consumptionDischargedBatteryHighwayWltp?: Maybe<Scalars['Float']>;
  consumptionDischargedBatteryIntownCityWltp?: Maybe<Scalars['Float']>;
  consumptionDischargedBatteryOutskirtsWltp?: Maybe<Scalars['Float']>;
  consumptionDischargedBatteryRuralRoadWltp?: Maybe<Scalars['Float']>;
  deliveryDate?: Maybe<Scalars['Date']>;
  electricConsumption?: Maybe<Scalars['Float']>;
  emission?: Maybe<Scalars['Int']>;
  emissionClassDetail?: Maybe<Scalars['String']>;
  engineType?: Maybe<Scalars['String']>;
  financeCalculatorOptions?: Maybe<FinanceCalculatorOptions>;
  financingDetails: Array<FinancingDetail>;
  fuelType?: Maybe<Scalars['String']>;
  hasLegalInfo?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<VehicleImage>>>;
  internalNumber?: Maybe<Scalars['String']>;
  isFixedPrice?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  isOrderVehicle?: Maybe<Scalars['Boolean']>;
  isPrivateSeller?: Maybe<Scalars['Boolean']>;
  linkPkwlabel?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  makeNameCdSysteme?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['Int']>;
  modelName?: Maybe<Scalars['String']>;
  mwst?: Maybe<Scalars['Boolean']>;
  powerHp?: Maybe<Scalars['Int']>;
  powerKw?: Maybe<Scalars['Int']>;
  powerconsumptionRoadWltp?: Maybe<Scalars['Float']>;
  powerconsumptionhighwayWltp?: Maybe<Scalars['Float']>;
  powerconsumptioninCityWltp?: Maybe<Scalars['Float']>;
  powerconsumptionoutskirtsWltp?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prices?: Maybe<Array<Maybe<VehiclePrice>>>;
  registeredIn?: Maybe<Scalars['DateRegister']>;
  similarVehicles?: Maybe<Array<Vehicle>>;
  title: Scalars['String'];
  trim?: Maybe<Scalars['String']>;
  vehicleCondition?: Maybe<Scalars['String']>;
  vehicleDetail?: Maybe<VehicleDetail>;
  vin?: Maybe<Scalars['String']>;
  wltConsumption?: Maybe<Scalars['String']>;
  wltConsumptionElectric?: Maybe<Scalars['String']>;
  wltEmission?: Maybe<Scalars['Int']>;
};

export type VehicleConditionFacet = {
  __typename?: 'VehicleConditionFacet';
  condition?: Maybe<Array<Maybe<Condition>>>;
  maxOwners: Scalars['Int'];
  maxYear: Scalars['Int'];
  minYear: Scalars['Int'];
};

export type VehicleConditionFilter = {
  condition?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxOwners?: InputMaybe<Scalars['Int']>;
  maxYear?: InputMaybe<Scalars['Int']>;
  mileage?: InputMaybe<Scalars['Int']>;
  minYear?: InputMaybe<Scalars['Int']>;
};

export type VehicleDetail = {
  __typename?: 'VehicleDetail';
  comfort?: Maybe<Array<Maybe<Scalars['String']>>>;
  concreteProductIds: Array<Scalars['String']>;
  dealer?: Maybe<Dealer>;
  entertainment?: Maybe<Array<Maybe<Scalars['String']>>>;
  environment?: Maybe<Environment>;
  highlights?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  interior?: Maybe<Interior>;
  internalId?: Maybe<Scalars['String']>;
  security?: Maybe<Array<Maybe<Scalars['String']>>>;
  sellerLocation?: Maybe<Location>;
  sellerVehicleInfo?: Maybe<Scalars['String']>;
  vehicleHistory?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type VehicleFilterOptions = {
  bodyColors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  brands?: InputMaybe<Array<InputMaybe<BrandFilter>>>;
  drive?: InputMaybe<DriveFilter>;
  emission?: InputMaybe<EmissionFilter>;
  equipment?: InputMaybe<EquipmentFilter>;
  fuelType?: InputMaybe<FuelTypeFilter>;
  interior?: InputMaybe<InteriorFilter>;
  location?: InputMaybe<LocationFilterInput>;
  merchantUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modelGroup?: InputMaybe<Scalars['String']>;
  priceRange?: InputMaybe<PriceFilter>;
  vehicleCondition?: InputMaybe<VehicleConditionFilter>;
  vehicleType?: InputMaybe<VehicleTypeFilter>;
};

export type VehicleImage = {
  __typename?: 'VehicleImage';
  externalUrlLarge: Scalars['String'];
  externalUrlSmall: Scalars['String'];
};

export type VehicleOption = {
  __typename?: 'VehicleOption';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type VehicleOptionInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type VehiclePrice = {
  __typename?: 'VehiclePrice';
  grossAmount?: Maybe<Scalars['Float']>;
  netAmount?: Maybe<Scalars['Float']>;
  priceTypeName: VehiclePriceType;
};

export enum VehiclePriceType {
  BankingFinancing = 'BANKING_FINANCING',
  BankingLeasing = 'BANKING_LEASING',
  Default = 'DEFAULT'
}

export type VehicleSearchResult = AggregatedSearchResult & {
  __typename?: 'VehicleSearchResult';
  aggregation?: Maybe<SearchResultAggregation>;
  results?: Maybe<Array<Vehicle>>;
};

export type VehicleSortingOptions = {
  direction?: InputMaybe<SortingDirection>;
  subject?: InputMaybe<VehicleSortingSubject>;
};

export enum VehicleSortingSubject {
  Added = 'ADDED',
  FinanceRate = 'FINANCE_RATE',
  LeasingRate = 'LEASING_RATE',
  Mileage = 'MILEAGE',
  Price = 'PRICE',
  Registered = 'REGISTERED',
  Relevance = 'RELEVANCE'
}

export type VehicleType = {
  __typename?: 'VehicleType';
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type VehicleTypeFacet = {
  __typename?: 'VehicleTypeFacet';
  doors?: Maybe<Array<Maybe<Door>>>;
  maxSeats?: Maybe<Scalars['Int']>;
  vehicleType?: Maybe<Array<Maybe<VehicleType>>>;
};

export type VehicleTypeFilter = {
  doors?: InputMaybe<Array<InputMaybe<DoorCount>>>;
  maxSeats?: InputMaybe<Scalars['Int']>;
  minSeats?: InputMaybe<Scalars['Int']>;
  vehicleType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum Weekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum WhiteLabelConfigEnvironment {
  Development = 'DEVELOPMENT',
  Production = 'PRODUCTION',
  Uat = 'UAT'
}

export type WhiteLabelDefaultSortingResponse = {
  __typename?: 'WhiteLabelDefaultSortingResponse';
  direction: SortingDirection;
  subject: VehicleSortingSubject;
};

export type WhiteLabelResponse = {
  __typename?: 'WhiteLabelResponse';
  brandAccessories?: Maybe<Array<Maybe<BrandAccessory>>>;
  brandButtonTextColor?: Maybe<Scalars['String']>;
  brandColor: Scalars['String'];
  brandColorContrast: Scalars['String'];
  catalogDefaultSorting: WhiteLabelDefaultSortingResponse;
  customScripts?: Maybe<Scalars['String']>;
  dataPrivacyUrl: Scalars['String'];
  domain: Scalars['String'];
  enabledFeatures?: Maybe<Array<Maybe<Feature>>>;
  imprintUrl: Scalars['String'];
  logo: Scalars['String'];
  make: Scalars['String'];
  merchantName: Scalars['String'];
  merchantOrigin: Scalars['String'];
  merchantUuids: Array<Scalars['String']>;
  shopUrl: Scalars['String'];
  storyBlokResponse?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  termsAndConditionsUrl: Scalars['String'];
  trackingId?: Maybe<Scalars['String']>;
};

export type WidgetConfiguration = {
  __typename?: 'WidgetConfiguration';
  bulletPoints?: Maybe<Array<Maybe<Scalars['String']>>>;
  fontFamily?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  imprintUrl?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  subHeadline?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
};

export type WorkshopServiceAvailableDay = {
  __typename?: 'WorkshopServiceAvailableDay';
  available: Scalars['Boolean'];
  day: Scalars['String'];
  time: Scalars['String'];
};

export type WorkshopServiceCategory = {
  __typename?: 'WorkshopServiceCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  services?: Maybe<Array<Service>>;
  title: Scalars['String'];
};

export type WorkshopServiceLocationFinderInput = {
  fuelType?: InputMaybe<Scalars['String']>;
  geoCoordinates: GeoCoordinatesInput;
  make?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
  registeredIn?: InputMaybe<Scalars['DateRegister']>;
  serviceSku: Scalars['ID'];
};
